/**
 * Created by user on 2020/6/1.
 */

/**
 * 一對一轉換確認表，僅用於測試用 在此表內任何更動都不會影響編譯後結果
 *
 * 並且 t 不等於 c
 */
export const table_1v1 = {

	'贛': '赣',
	'戇': '戆',

} as const

export default table_1v1

